import React from "react";
import { useCart } from "../../contexts/CartContext";
import { containsAnEmailAddress } from "../../utils/geo";

function ShareCartForm({ onClose }) {
  const { shareCart } = useCart();

  const [email, setEmail] = React.useState("");
  const [client, setClient] = React.useState("");
  const [comments, setComments] = React.useState("");
  const [status, setStatus] = React.useState(null); // 'success' | 'error' | null
  const [submitting, setSubmitting] = React.useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!containsAnEmailAddress(email)) {
      setStatus("error");
      return;
    }

    setSubmitting(true);
    try {
      await shareCart({ email, client, comments });
      setStatus("success");
      setTimeout(() => {
        setStatus(null);
        if (onClose) onClose();
      }, 3000);
    } catch {
      setStatus("error");
    }
    setSubmitting(false);
  }

  function handlePrint() {
    window.print();
  }

  return (
    <div className="share-email modal share-modal" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="actions">
              <button className="btn print" onClick={handlePrint}>
                <i className="glyphicon glyphicon-print" />
              </button>
            </div>
            <h4 className="sub-headliner">Share</h4>
            <div className="share-error">
              {status === "error" && "Please enter a valid email address."}
            </div>
          </div>

          <ul className="nav nav-tabs">
            <li className="active"><a>E-mail</a></li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane active">
              <div className="modal-body share-content">
                <label className="label-no-transform">* E-mail this information to:</label>
                <input
                  id="share-email-cart"
                  name="email"
                  className="input share-address"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                />

                <label className="label-no-transform optional">Optional information:</label>
                <input
                  className="input share-client"
                  type="text"
                  value={client}
                  onChange={(e) => setClient(e.target.value)}
                  placeholder="Client name"
                />

                <textarea
                  className="input share-comments"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Additional comments"
                />

                <button
                  className="email-result btn btn-primary"
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? "Sending..." : "Send e-mail"}
                </button>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-default" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>

      {status === "success" && (
        <div className="share-confirmation open">
          You should receive your email shortly...
        </div>
      )}
    </div>
  );
}

export default ShareCartForm;
